const pictureLinkWidgets = document.querySelectorAll('.swt-Ultimate-PictureLink');
window.fireOnVisible(pictureLinkWidgets, async (widget) => {
    await import('./css/swt-Ultimate_PictureLink.scss');
    await import('../../../../assets/frontend/js/tcmsSlider/tcms_base_tcmsSlider.ts').then(({ TcmsSlider }) => {
        const minWidthValueDesktop = document.body.classList.contains('thin') ? 316 : 306;
        const slidesPerViewValueDesktop = document.body.classList.contains('thin') ? 3 : 4;
        const sliderElement = widget?.querySelector('.tcmsSlider');

        const pictureLinkSlider = new TcmsSlider(sliderElement, {
            slidesPerView: 1.2,
            slideMinWidth: 312.5,
            breakpoints: {
                740: {
                    navigation: true,
                    slidesPerView: slidesPerViewValueDesktop,
                    slideMinWidth: minWidthValueDesktop
                },
                1025: {
                    slidesPerView: slidesPerViewValueDesktop,
                    slideMinWidth: minWidthValueDesktop
                }
            }
        });

        if (sliderElement) {
            const accordionWrapper = sliderElement.closest('.accordion-wrapper');
            if (accordionWrapper) {
                const accordionToggleElem = accordionWrapper.querySelector('[data-accordion="true"]');
                accordionToggleElem.addEventListener('click', () => {
                    pictureLinkSlider?.updateSlider();
                });
            }
        }
    });
});
